import { createFileRoute } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import PublicFeedbackSurveyPage from '../../pages/PublicFeedbackSurveyPage';
import { getReviewToken } from '../../server/getReviewToken';
import { destinationMiddleware } from '../../server/middleware/destinationMiddleware';

const loadDestination = createServerFn()
    .middleware([destinationMiddleware])
    .handler(async ({ context }) => {
        return context.destination;
    });

export const Route = createFileRoute('/feedback/$token')({
    beforeLoad: async () => {
        try {
            const destination = await loadDestination();
            return { destination };
        } catch (error) {
            console.error('Failed to load destination:', error);
            throw error;
        }
    },
    loader: async ({ params, context }) => {
        const { token } = params;
        const initialData = await getReviewToken({ data: { token } }).catch((err) => ({
            error: err.message || 'Invalid or expired survey link.',
        }));
        return {
            token,
            initialData,
            destination: context.destination,
        };
    },
    head: ({ loaderData, params }) => {
        const siteUrl = (loaderData?.destination?.url || 'https://www.maasaimara.com').replace(/\/$/, '');
        const canonicalUrl = `${siteUrl}/feedback/${params.token}`;
        return {
            meta: [
                { title: 'Feedback Survey | Wilderness Bookings' },
                { name: 'description', content: 'Share your feedback on your booking experience with Wilderness Bookings.' },
                { property: 'og:title', content: 'Feedback Survey | Wilderness Bookings' },
                { property: 'og:type', content: 'website' },
                { property: 'og:url', content: canonicalUrl },
                { name: 'robots', content: 'noindex, nofollow' },
            ],
            links: [
                { rel: 'canonical', href: canonicalUrl },
            ],
        };
    },
    component: PublicFeedbackSurveyPage,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
});
